<ion-content>
  <div class="px-4 py-2 padding-bottom-configuration">
    <app-header-configuration
      [title]="'P00039.installation.projector' | translate"
      [description]="'P00039.installation.projecteur.texte' | translate"
    >
    </app-header-configuration>

    <app-label-configuration
      [title]="'P00039.installation.projectorType' | translate"
      [titleListe]="'P00039.installation.projector' | translate"
      [value]="actionStack!.getValue('eclairageStandardITypeEclairage')"
      [liste]="
        P00039EclairageTypeEnumFn(getMasterFirmwareVersionFromPool(pool!)!)
      "
      [namedList]="P00039EclairageNameEnum"
      [description]="
        'P00039.installation.projecteur.text.projector' | translate
      "
      (onPress)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.Eclairage_Installation,
          'eclairageStandardITypeEclairage',
          $event,
          null
        )
      "
    >
    </app-label-configuration>

    @if (this.actionStack!.getValue('eclairageStandardITypeEclairage') === 0) {
      <app-label-configuration
        [title]="'P00039.installation.projectorCouleur' | translate"
        [titleListe]="'P00039.installation.dureeRuptureAlim' | translate"
        [value]="
          actionStack!.getValue('eclairageStandardIDureeRuptureAlimentation')
        "
        [liste]="P00039RuptureAlimentationEnum"
        [description]="'P00039.installation.text.time' | translate"
        (onPress)="
          this.actionStack!.editValue(
            P00039DataRxTxIndex.Eclairage_Installation,
            'eclairageStandardIDureeRuptureAlimentation',
            $event,
            null
          )
        "
      >
      </app-label-configuration>
    }
  </div>
</ion-content>

<div class="position-absolute start-0 end-0 bottom-0 bg-white px-4 py-2">
  <div class="row">
    <div class="col-6 text-start">
      <ion-button
        color="medium"
        expand="block"
        fill="outline"
        class="mb-3"
        (click)="this.prev()"
      >
        {{ 'generic.retour' | translate }}
      </ion-button>
    </div>
    <div class="col-6 text-end">
      <ion-button color="primary" expand="block" (click)="onSubmit()">
        {{ 'generic.next' | translate }}
      </ion-button>
    </div>
  </div>
</div>
